/* global Sys:true */
// the above line makes the linter ignore Sys.* errors, Sys DOES exist, it is part of ASP.Net, but logically it does NOT exist 'here'
// requires for external dependencies and other global stuff go here
/* eslint-disable no-unused-vars */
import helper from './util/helper';
import axios from 'axios';
import $ from 'jquery';
import tether from 'tether';
import * as bootstrap from 'bootstrap';
import enquire from 'enquire.js';
import slick from 'slick-carousel';
import WebFont from 'webfontloader';
import fancybox from '@fancyapps/fancybox';

/* eslint-enable no-unused-vars */

// make sure Promise is present
require('es6-promise/auto');

// use this function to add things that you want to run when the application runs first time (when init is called)
function startup()
{
    WebFont.load({
        google: {
            families: ['Open Sans:400,400i,700,700i', 'Cookie']
        }
    });
}


// media query berekenen
var menucheck = false;
var isBrowserHandheld = false;
var deviceAgent = navigator.userAgent.toLowerCase();
var deviceAgentMobiel = deviceAgent.match(/(iphone|ipod|ipad|android|webos|blackberry|iemobile|opera mini)/);

function viewport() {
    var viewportwidth;
    if (typeof window.innerWidth !== 'undefined') {
        viewportwidth = window.innerWidth;
    }
    else if (typeof document.documentElement !== 'undefined' && typeof document.documentElement.clientWidth !== 'undefined' && document.documentElement.clientWidth !== 0) {
        viewportwidth = document.documentElement.clientWidth;
    }
    else {
        viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
    }
    return viewportwidth;
}

function menuToggle() {
    $('li.dropdown > a:first-child').off('click').on('click', function (e) {
        if (isBrowserHandheld && viewport() >= 992) menucheck = true;
        else menucheck = false;

        if (menucheck) {
            var $el = $(this).parent();
            if ($el.hasClass('subopen')) {
                var $a = $el.children('a.dropdown-toggle');
                if ($a.length && $a.attr('href')) window.location.href = $a.attr('href');
            } else {
                $el.addClass('subopen');
                e.preventDefault();
            }
        }
    });
};

// use this function for things you want to happen on (partial-)postback (i.e.: $(document).ready())
function onDocLoad()
{
    var $body = $('body');
    $('#togglesearch').off('click').on('click', function(e) {
        e.preventDefault();
        $body.toggleClass('searchopen');
        if ($body.hasClass('searchopen')) $('#p_lt_ctl04_Search_txtWord').focus();
    });

    $('.navbar-toggler').off('click').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('collapsed')) {
            $body.addClass('mainmenuopen');
        } else {
            $body.removeClass('mainmenuopen');
        }
    });

    if ($('.reviewslides .slide').length > 1) {
        $('.reviewslides').slick({
            arrows: true,
            autoplay: false,
            dots: false,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            fade: true,
            cssEase: 'linear',
            prevArrow: $('#slideprev'),
            nextArrow: $('#slidenext')
        });
    }

    if ($('.imageslides .slide').length > 1) {
        $('.imageslides').slick({
            adaptiveHeight: true,
            arrows: true,
            autoplay: false,
            dots: false,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: $('#slideprev'),
            nextArrow: $('#slidenext')
        });
    }

    if ($('.wbhslider .wbhslider__item').length > 1) {
        $('.wbhslider').slick({
            arrows: true,
            autoplay: true,
            dots: true,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false
        });
    }

    if ($('.housingslider .slide').length > 1) {
        $('.housingslider').slick({
            adaptiveHeight: true,
            arrows: true,
            autoplay: false,
            dots: false,
            speed: 450,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: $('#slideprev'),
            nextArrow: $('#slidenext'),
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        adaptiveHeight: false
                    }
                }
            ]
        });
    }

    if ($('#headerslider').length > 1) {
        $('#headerslider').slick({
            arrows: false,
            autoplay: true,
            autoplayspeed: 2000,
            dots: true,
            speed: 800,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    var stickyJobDiv = $('.jobdetails-sticky-content');
    var stickyJobActivePx = (viewport() >= 1200) ? 600 : (viewport() >= 992) ? 900 : 1000;

    $(window).off('scroll').on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 10) {
            $('#logo').addClass('logosmall');
        } else {
            $('#logo').removeClass('logosmall');
        }

        if (stickyJobDiv != null) {
            if (scroll > stickyJobActivePx) {
                $('body').addClass('jobdetails-sticky');
            } else {
                $('body').removeClass('jobdetails-sticky');
            }
        }
    });

    $('a#fontRegular').off('click').on('click', function (e) {
        e.preventDefault();
        changeSize($body, 'fontRegular');
    });

    $('a#fontBigger').off('click').on('click', function (e) {
        e.preventDefault();
        changeSize($body, 'fontBigger');
    });

    $('a#fontBiggest').off('click').on('click', function (e) {
        e.preventDefault();
        changeSize($body, 'fontBiggest');
    });

    $('a.fbzoom').fancybox();
    $('a.fbvideozoom').fancybox({
        'hideOnContentClick': true
    });

    $('a.fbslider').fancybox({
        animationEffect: 'fade',
        hash: false,
        backFocus: false
    });

    var fontSize = getCookie('FontSize');
    if (fontSize) $body.addClass(fontSize);

    if (!$body.hasClass('EditMode')) {
        if ($('.phfootercta').length > 0) {
            $('.phfootercta').each(function (i) {
                if ($('.ctablock', this).length === 0) {
                    $(this).remove();
                }
            });
        }

        if ($('.footeronlycta').length > 0) {
            if ($('.phfootercta', this).length === 0) {
                $('.footeronlycta').addClass('isempty');
            }
        }
    }

    $('a.scrolltofacts').off('click').on('click', function (e) {
        e.preventDefault();
        var factslist = $('#factslist').offset();
        var scrollpos = factslist.top;
        $('html, body').animate({ scrollTop: scrollpos }, 650);
    });

    var strTrengoKey = 'TODO';
    // var strTrengoKey = 'Ka9lJNi0HGpyGsN';
    // var hostname = '' + document.location.hostname;
    // if (hostname.indexOf('margaklompe') >= 0) strTrengoKey = 'Ka9lJNi0HGpyGsN';

    if (strTrengoKey != null) {
        window.Trengo = window.Trengo || {};
        window.Trengo.key = strTrengoKey;

        (function (d, script) {
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://cdn.widget.trengo.eu/widget.js';
            d.getElementsByTagName('head')[0].appendChild(script);
        }(document));
    }

    var homevideo = document.getElementById('homevideo');
    if (homevideo) {
        var interval = setInterval(function () {
            if (homevideo.readyState === 4) {
                $body.addClass('videoloaded');
                clearInterval(interval);
            }
        }, 200);
    }

    if (deviceAgentMobiel) {
        isBrowserHandheld = true;
        $('body').addClass('ishandheld');
        $('.sfeervideoplayer .controls').addClass('paused');
    } else {
        isBrowserHandheld = false;
        $('body').removeClass('ishandheld');
    }

    menuToggle();

    var sharedropdownbtn = document.getElementById('sharedropdownbtn');
    if (sharedropdownbtn) {
        sharedropdownbtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.target.classList.toggle('open');
        });
    }
}

function changeSize(element, size) {
    var current = getCookie('FontSize');
    if (current) element.removeClass(current);
    element.addClass(size);
    setCookie('FontSize', size, 365);
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

// Init function, can be used for startup stuff
function init()
{
    try
    {
        let done = false;
        startup();
        $(document).ready(() =>
        {
            onDocLoad();
            done = true;
            Sys.Application.add_load((sender, args) =>
            {
                if (!done) onDocLoad();
            });
        });
    }
    catch (ex)
    {
    }
}

export default {
    init
};



// WEBPACK FOOTER //
// ./CMS/scripts/global.js